import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { UserFunctionDto, UserProfileDto, UserProfileNoIdDto } from 'src/app/shared/models/user/user-profile-dto';
import { PermissionService } from 'src/app/shared/services/permission/permission.service';

@Component({
    selector: 'app-user-profile-form',
    templateUrl: './user-profile-form.component.html',
    standalone: false
})
export class UserProfileFormComponent implements OnInit {
  @Input() readonly: boolean = false;
  @Input() formData: UserProfileDto = null;

  @Output() change = new EventEmitter();

  loading = false;
  form: FormGroup = this.builder.group({
    name: this.builder.control('', [Validators.required]),
    userType: this.builder.control('', [Validators.required]),
    permissionsIds: this.builder.array([])
  });

  data = {
    permissions: [] as UserFunctionDto[]
  };

  constructor(private readonly builder: FormBuilder, private readonly permissionService: PermissionService) {}

  get functions() {
    return this.data.permissions;
  }

  get permissions() {
    return this.form.get('permissionsIds') as FormArray;
  }

  get values() {
    const checkedPermissions = this.permissions.value as boolean[];
    const permissionsIds = checkedPermissions
      .map((value, index) => ({ value, permission: this.functions[index] }))
      .filter((userFunction) => userFunction.value)
      .map((userFunction) => userFunction.permission.id);
    return { ...this.form.value, permissionsIds };
  }

  fillForm() {
    this.permissions.clear();
    this.data.permissions.forEach(() => {
      this.permissions.push(new FormControl(false));
    });
    if (this.formData != null) {
      this.form.patchValue({
        name: this.formData?.name,
        userType: this.formData?.userType
      });
      this.formData.permissions.forEach((userPermission) => {
        const index = this.data.permissions.findIndex((formPermission) => formPermission.id == userPermission.userFunction.id);
        if (index > -1) {
          this.permissions.at(index).setValue(true);
        }
      });
    }
  }

  ngOnInit() {
    this.loading = true;

    forkJoin({
      permissions: this.permissionService.findAll()
    })
      .subscribe({
        next: (result) => (this.data = result)
      })
      .add(() => {
        this.loading = false;
        this.fillForm();
      });

    this.form.valueChanges.subscribe(() => {
      this.change.emit({
        form: this.form,
        values: this.values
      });
    });

    if (this.readonly) {
      this.form.disable();
    }
  }
}
